<template>
	<div class="container" aria-label="当前为登录和注册页面，您必须先登录才能使用本平台的大部分服务，若您还没有账号，请点击注册选项卡，填写表单注册。" tabindex="0">
		<div class="tabs">
			<div
				class="tab"
				:class="{ active: activeTab === 'login' }"
				@click="handleTab('login')"
				@keydown.enter="handleTab('login')"
				tabindex="0"
				role="tab"
				:aria-label="(activeTab === 'login' ? '已选中 ' : '') + '登录'"
			>
				登录
			</div>
			<div
				class="tab"
				:class="{ active: activeTab === 'register' }"
				@click="handleTab('register')"
				@keydown.enter="handleTab('register')"
				tabindex="0"
				role="tab"
				:aria-label="(activeTab === 'register' ? '已选中 ' : '') + '注册'"
			>
				注册
			</div>
		</div>

		<!-- 登录表单 -->
		<form @submit.prevent="validateLogin" class="form" v-if="activeTab === 'login'">
			<div class="form-group">
				<label for="loginUsername">用户名：</label>
				<input type="text" id="loginUsername" class="input-field" v-model.trim="loginData.userName" />
			</div>
			<div class="form-group">
				<label for="loginPassword">密码：</label>
				<input type="password" id="loginPassword" class="input-field" v-model.trim="loginData.password" />
			</div>

			<div class="button-container">
				<button type="submit" tabindex="0" class="submit-button" ref="submitButton">登录</button>
			</div>
		</form>

		<!-- 注册表单 -->
		<form @submit.prevent="validateRegister" class="form" v-if="activeTab === 'register'">
			<div class="form-group">
				<label for="registerUsername">用户名：</label>
				<input type="text" id="registerUsername" class="input-field" v-model.trim="registerData.userName" />
			</div>
			<div class="form-group">
				<label for="registerPassword">密码：</label>
				<input type="password" id="registerPassword" class="input-field" v-model.trim="registerData.password" />
			</div>
			<div class="form-group">
				<label for="confirmPassword">确认密码：</label>
				<input type="password" id="confirmPassword" class="input-field" v-model.trim="registerData.confirmPassword" />
			</div>
			<!--
			<div class="form-group">
				<label for="registerRealname">真实姓名：</label>
				<input id="registerRealname" class="input-field" v-model.trim="registerData.realName" />
			</div>
			<div class="form-group">
				<label for="registerMyphone">手机号：</label>
				<input id="registerMyphone" class="input-field" v-model.trim="registerData.myPhone" />
			</div>
			<div class="form-group">
				<label for="registerSchool">学校：</label>
				<input id="registerSchool" class="input-field" v-model.trim="registerData.school" />
			</div>
			<div class="form-group">
				<label for="registerGrade">年级：</label>
				<input id="registerGrade" class="input-field" v-model.trim="registerData.grade" />
			</div>
			-->
			<div class="button-container">
				<button type="submit" tabindex="0" class="submit-button" ref="submitButton">注册</button>
			</div>
		</form>

		<!-- 弹出提示框 -->
		<div class="modal" v-if="showModal">
			<div class="modal-content">
				<p ref="modalContent" tabindex="0">{{ modalMessage }}</p>
				<button class="modal-button" @click="closeModal" @keydown.space.prevent="closeModal">
					知道了
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import {baseUrl, loginUrl, registerUrl } from '@/constants/urls.js';


export default {
	data() {
		return {
			activeTab: 'login',
			loginData: {
				userName: '',
				password: ''
			},
			registerData: {
				userName: '',
				password: '',
				confirmPassword: '',
				// realName: '',
				// myPhone: '',
				// school: '',
				// grade: ''
			},
			showModal: false,
			modalMessage: ''
		};
	},
	mounted() {
	},
	methods: {
		handleTab(tab) {
			this.activeTab = tab;
		},
		showModalMessage(message) {
			this.modalMessage = message;
			this.showModal = true;
			this.$nextTick(() => this.$refs.modalContent.focus());
		},
		validateLogin() {
			if (!this.loginData.userName || !this.loginData.password) {
				this.showModalMessage('用户名和密码不能为空');
				return;
			}
			
			axios.post(`${baseUrl}${loginUrl}`, this.loginData)
				.then(response => {
					if (response.data.status === "OK") {
						this.$router.push({ name: "Home" });
					} else if (response.data.status === "NO") {
						this.showModalMessage('用户名或密码错误');
					}
				})
				.catch(error => {
					this.showModalMessage('发生错误，错误信息：' + error);
				});
		},
		validateRegister() {
			const fieldMap = {
				userName: "用户名",
				password: "密码",
				confirmPassword: "确认密码",
				// realName: "真实姓名",
				// myPhone: "手机号",
				// school: "学校",
				// grade: "年级"
			};
			for (let key of Object.keys(this.registerData)) {
				if (!this.registerData[key]){
					this.showModalMessage(fieldMap[key]+'不能为空');
					return;
				}
			}
			if (this.registerData.password !== this.registerData.confirmPassword) {
				this.showModalMessage('两次输入的密码不一致');
				return;
			}
			
			axios.post(`${baseUrl}${registerUrl}`, this.registerData)
				.then(response => {
					if (response.data.status === "OK") {
						this.showModalMessage('注册成功！');
						this.activeTab = 'login';
					} else if (response.data.status === "EXISTED") {
						this.showModalMessage('用户名已存在');
					}
				})
				.catch(error => {
					this.showModalMessage('发生错误，错误信息：' + error);
				});
		},
		closeModal() {
			this.showModal = false;
			this.$nextTick(() => this.$refs.submitButton.focus());
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 50%;
	margin: 0 auto;
}

.tabs {
	display: flex;
	flex-direction: row;
	width: 70%;
	height: 40px;
	margin-top: 10vh;
}

.tab {
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	text-align: center;
	padding: 10px;
	border: 1px solid #ccc;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.active {
	background: linear-gradient(to bottom, rgb(100, 255, 100), rgb(204, 255, 204));
	color: #006400;
	font-weight: bold;
}

.form {
	width: 100%;
	max-width: 500px;
	margin-top: 20px;
}

.form-group {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}

label {
	width: 30%;
	text-align: right;
	margin-right: 10px;
	font-size: 16px;
}

.input-field {
	flex: 1;
	width: 100%;
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
}

.button-container {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.submit-button {
	margin-top: 20px;
	width: 30%;
	height: 50px;
	background: linear-gradient(to bottom, rgb(0, 180, 0), rgb(0, 255, 0));
	border: none;
	border-radius: 10%;
	cursor: pointer;
}

.submit-button:hover {
	background-color: #218838;
}

.modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-content {
	background: white;
	padding: 20px;
	border-radius: 10px;
	text-align: center;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	width: 300px;
	outline: none;
}

.modal-button {
	margin-top: 20px;
	padding: 10px 20px;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	font-size: 16px;
}

.modal-button:hover {
	background-color: #0056b3;
}

@media (max-width: 500px){
	.container{
		width: 100%;
	}
}
</style>
